import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import Page from "src/components/Page";
import View from "./view";

function index(props) {
  localStorage.removeItem("@imageSingle");

  


  return (
  
    <Page title='How To Sell Leon Gallery | Leon Gallery Premier Art Auction House in the Philippines'>
      <View />
    </Page>
  
  );
}

export default index;
